import { render, staticRenderFns } from "./AIDataSetMain.vue?vue&type=template&id=9031f1b4&scoped=true"
import script from "./AIDataSetMain.vue?vue&type=script&lang=js"
export * from "./AIDataSetMain.vue?vue&type=script&lang=js"
import style0 from "./AIDataSetMain.vue?vue&type=style&index=0&id=9031f1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9031f1b4",
  null
  
)

export default component.exports